import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Model = models.PorcentajesTarifaPagoChofer;
interface Props {
    value: Model;
    onChange: (x: Model) => void;
}
export class Porcentajes extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    render() {
        const props = this.props;
        const Num = this.getField(kea.Number);

        return (
            <div>
                <kea.Panel title="Porcentajes" >
                {kea.autogrid(3, [
                    <Num field="Flete" label="Flete" format="percentage" />,
                    <Num field="Seguro" label="Seguro" format="percentage" />,
                    <Num field="PrecioZE" label="Precio de Z.E." format="percentage" />,
                    <Num field="Subtotal" label="Subtotal" format="percentage" />,
                ])}
                </kea.Panel>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapagochofer/edit/porcentajes.tsx